import { useState, useCallback, useMemo } from 'react';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyFieldsModelPerformanceMapData,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function useMapDownload() {
  const [onDownloadClick, setOnDownloadClick] = useState<() => void>(() => () => {});
  const mapData = useSelector(selectMeteorologyFieldsModelPerformanceMapData);

  const filename = useMemo(() => {
    if (!mapData) {
      return '';
    }

    const timestamp = format(new Date(), 'yyyyMMdd_HHmmss');
    return `desempenho_modelos_${timestamp}.png`;
  }, [mapData]);

  const isDownloadDisabled = useCallback(
    () => !mapData || !mapData.geoJson || mapData.geoJson.features.length === 0,
    [mapData],
  );

  return {
    onDownloadClick,
    setOnDownloadClick,
    filename,
    isDownloadDisabled,
  };
}
